import React from 'react'

const SwapIcon = ({ color = "currentColor", size = 26, ...rest }) => {
    return (
        <svg {...rest} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 10L4 10L9.5 4" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4 14L20 14L14.5 20" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default SwapIcon